import jQuery from 'jquery';

const { UI } = Mobi2Go;
// Policies view
Mobi2Go.UI.View({
    name: 'policies',
    model: UI,
    el: '[data-view="policies"]',
    template: jQuery('[data-template="policies"]').html(),
    initialise() {
        this.modal = new Mobi2Go.UI.Modal(this.$el);
    },

    render(type) {
        const data = {
            type,
            text: null,
        };
        const that = this;
        this.$el.html(this.template(data)).attr('data-type', type);
        this.modal.open();

        Mobi2Go.app.serverRequest({
            api_version: 1,
            with_credentials: false,
            endpoint: `policy/${type}`,
            success(response) {
                data.text = response;
                that.$el.html(that.template(data));
            },
        });
    },
    DOM_listeners: {
        'click [data-close]': function() {
            this.modal.close();
        },
    },
    model_listeners: {
        showPolicy(policy_type) {
            switch (policy_type) {
                case 'cancellation':
                case 'refund':
                case 'delivery':
                case 'termsandconditions':
                case 'loyalty':
                case 'termsofuse':
                    break;
                default:
                    return;
            }

            this.render(policy_type);
        },
    },
});
